module.exports = __webpack_public_path__ + "static/specialsPlaceholder-e8586e567089b54c0429b47e0ac275eb.jpg";